<template>
  <div class="app-update">
    <div class="app-update__card">
      <div class="app-update__badge">
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
          <rect
            x="14.25"
            y="4.25"
            width="19.5"
            height="39.5"
            rx="4.75"
            stroke="#fff"
            stroke-width="2.5"
          />
          <path
            d="M24 33V18"
            stroke="#fff"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <path
            d="M18.5 23.5L24 18l5.5 5.5"
            stroke="#fff"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h2 class="app-update__title">השתדרגנו!</h2>
      <p class="app-update__text">
        גרסה חדשה ומשופרת מחכה לך בחנות האפליקציות. כדי להמשיך ליהנות מכל
        היכולות שלנו ללא תקלות, יש לעדכן את האפליקציה כעת.
      </p>
      <a class="app-update__bt" :href="storeUrl" target="_blank">לחנות</a>
      <p class="app-update__note">
        אם הכפתור לא פותח את החנות, יש לבצע את העדכון ידנית.
      </p>
    </div>
  </div>
</template>

<script>
import { getAppStoreUrl } from "../../utilities/globals";

export default {
  name: "AppUpdate",
  computed: {
    storeUrl() {
      return getAppStoreUrl();
    },
    /**
     * The name to search the store by. Kept as the store listing spells it,
     * in latin letters, because that is what the user has to type in.
     */
    appName() {
      return "MyMedical Doctors";
    }
  }
};
</script>

<style scoped>
.app-update {
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.app-update__card {
  width: 100%;
  max-width: 440px;
  box-sizing: border-box;
  padding: 38px 28px 32px;
  background: #fff;
  border-radius: 32px;
  text-align: center;
  box-shadow: 0px 24px 60px rgba(17, 84, 250, 0.18),
    0px 4px 14px rgba(0, 0, 0, 0.08);
  animation: app-update-in 0.35s cubic-bezier(0.2, 0.8, 0.3, 1.08) both;
}

.app-update__badge {
  width: 88px;
  height: 88px;
  margin: 0 auto 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1154fa, #30a6ff);
  box-shadow: 0px 12px 24px rgba(17, 84, 250, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-update__badge svg {
  display: block;
  width: 44px;
  height: 44px;
}

.app-update__title {
  margin: 0 0 14px;
  font-size: 36px;
  font-weight: bold;
  line-height: 1.1;
  color: var(--blue-dark);
}

.app-update__text {
  margin: 0 0 28px;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.45;
  color: #4a4a55;
}

.app-update__note {
  margin: 16px 0 0;
  font-size: 17px;
  font-weight: 300;
  line-height: 1.4;
  color: #8a8f9e;
}

.app-update__bt {
  display: block;
  width: 100%;
  box-sizing: border-box;
  height: 70px;
  line-height: 70px;
  border-radius: 45px;
  background: linear-gradient(to right, #1154fa, #30a6ff);
  color: #fff;
  font-size: 30px;
  font-weight: 400;
  text-align: center;
  box-shadow: 0px 10px 22px rgba(17, 84, 250, 0.3);
  transition: all 0.25s ease-in-out;
}

.app-update__bt:hover {
  background: linear-gradient(to right, #0d45d6, #1e94ee);
}

.app-update__bt:active {
  transform: scale(0.98);
}

@keyframes app-update-in {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media only screen and (max-width: 800px) {
  .app-update__card {
    padding: 30px 22px 26px;
    border-radius: 28px;
  }

  .app-update__badge {
    width: 74px;
    height: 74px;
    margin-bottom: 18px;
  }

  .app-update__badge svg {
    width: 38px;
    height: 38px;
  }

  .app-update__title {
    font-size: 28px;
  }

  .app-update__text {
    font-size: 20px;
    margin-bottom: 24px;
  }

  .app-update__note {
    font-size: 15px;
  }

  .app-update__bt {
    height: 58px;
    line-height: 58px;
    font-size: 24px;
  }
}
</style>
